export default class MobileNavigation {
  constructor() {
    this.folderLinks = document.querySelectorAll(".mobile-nav .nav-item.folder > a.nav-link")

    for (let link of this.folderLinks) {
      link.addEventListener("click", this.handleClick.bind(this))
    }
  }

  handleClick(event) {
    event.preventDefault()

    event.target.parentNode.classList.toggle("opened")
  }
}
